/**
 *
 */
export const createCommerceTrackingData = (action) => {
    const { product, unit, quantity, clickTarget } = action;
    return {
        _business_store_id: product?.vendor_id,
        _product_id: product?.id,
        product_name: product?.product_name,
        currency_code: product?.product_currency,
        unit_id: unit?.unit_id,
        unit_amount: unit?.unit_price,
        unit_url: unit?.unit_url,
        variant_options: unit?.unit_options?.[0],
        quantity,
        click_target: clickTarget,
    };
};
